export default [{
  path: '/user/view',
  name: 'viewuser',
  component: () => import('@/app/user/UserView'),
  meta: {
    resource: 'users',
    actions: ['read']
  }
}]
